import { render, staticRenderFns } from "./jjvc_product_info.vue?vue&type=template&id=e8b118f6&"
import script from "./jjvc_product_info.vue?vue&type=script&lang=js&"
export * from "./jjvc_product_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "jjvc_product_info.vue"
export default component.exports